/**   
 * 结算管理api
 */

export default {
  getStoreSettlementList: "/storeSettlement/listPage",  // 服务订单明细列表
  getSettlementOrderList: "/settlementOrder/listPage",  // 商品订单明细列表
  getSettlementOrderDetail: "/settlementOrder/detail",  // 商品订单明细列表-详情
  getProjectConsumeList: '/projectConsume/list',  // 提成明细

  /**
  * 提现申请
  */

  // 提现弹窗-下拉选择收款账户
  getExtractAccountDrop: "/extractAccount/drop",
  // 收款账号管理-列表
  getExtractAccountListPage: "/extractAccount/listPage",
  // 收款账号管理-新增
  getExtractAccountAdd: "/extractAccount/add",
  // 收款账号管理-编辑
  getExtractAccountUpdate: "/extractAccount/update",
  // 收款账号管理-删除
  getExtractAccountDelete: "/extractAccount/delete",

  // 列表顶部账户总览
  getSelectSettlementAccount: "/settlement_account/select_shop_settlement_account",

  // 提现申请列表
  getSupplierExtractApplyList: "/extractApply/pageList",
  // 提现申请列表-查看详情
  getSupplierExtractApplyListDetail: "/extractApply/pageListDetails",
  // 提现申请
  postSupplierExtractApply: "/extractApply/shopExtractApply",
};